// extracted by mini-css-extract-plugin
export var explainable = "_gp-a";
export var printerCard = "_gp-1";
export var printerCardConfigured = "_gp-2";
export var printerCardError = "_gp-3";
export var printerCardsContainer = "_gp-0";
export var printerIcon = "_gp-8";
export var printerIconConfigured = "_gp-5";
export var printerIconContainer = "_gp-4";
export var printerIconError = "_gp-6";
export var printerIconUnconfigured = "_gp-7";
export var workstationsTableCard = "_gp-9";